// if modelFor turns out to be a bottleneck we should replace with a Map
// and clear it during store teardown.
const AvailableShims = new WeakMap();
export function getShimClass(store, modelName) {
  let shims = AvailableShims.get(store);
  if (!shims) {
    shims = Object.create(null);
    AvailableShims.set(store, shims);
  }
  let shim = shims[modelName];
  if (shim === undefined) {
    shim = shims[modelName] = new ShimModelClass(store, modelName);
  }
  return shim;
}
function mapFromHash(hash) {
  let map = new Map();
  for (let i in hash) {
    if (Object.prototype.hasOwnProperty.call(hash, i)) {
      map.set(i, hash[i]);
    }
  }
  return map;
}

// Mimics the static apis of DSModel
export default class ShimModelClass {
  constructor(store, modelName) {
    this.__store = store;
    this.modelName = modelName;
  }
  get fields() {
    let attrs = this.__store.getSchemaDefinitionService().attributesDefinitionFor({
      type: this.modelName
    });
    let relationships = this.__store.getSchemaDefinitionService().relationshipsDefinitionFor({
      type: this.modelName
    });
    let fields = new Map();
    Object.keys(attrs).forEach(key => fields.set(key, 'attribute'));
    Object.keys(relationships).forEach(key => fields.set(key, relationships[key].kind));
    return fields;
  }
  get attributes() {
    let attrs = this.__store.getSchemaDefinitionService().attributesDefinitionFor({
      type: this.modelName
    });
    return mapFromHash(attrs);
  }
  get relationshipsByName() {
    let relationships = this.__store.getSchemaDefinitionService().relationshipsDefinitionFor({
      type: this.modelName
    });
    return mapFromHash(relationships);
  }
  eachAttribute(callback, binding) {
    let attrDefs = this.__store.getSchemaDefinitionService().attributesDefinitionFor({
      type: this.modelName
    });
    Object.keys(attrDefs).forEach(key => {
      callback.call(binding, key, attrDefs[key]);
    });
  }
  eachRelationship(callback, binding) {
    let relationshipDefs = this.__store.getSchemaDefinitionService().relationshipsDefinitionFor({
      type: this.modelName
    });
    Object.keys(relationshipDefs).forEach(key => {
      callback.call(binding, key, relationshipDefs[key]);
    });
  }
  eachTransformedAttribute(callback, binding) {
    let relationshipDefs = this.__store.getSchemaDefinitionService().relationshipsDefinitionFor({
      type: this.modelName
    });
    Object.keys(relationshipDefs).forEach(key => {
      if (relationshipDefs[key].type) {
        callback.call(binding, key, relationshipDefs[key]);
      }
    });
  }
}